<template>
  <div v-if="isVisible" class="container">
    <h1>OrganizationEditor</h1>
    <div class="d-flex mx-auto">
      <iframe v-if="iframeUrl" :src="iframeUrl" style="height:1200px;width:100%" title="Typeform"></iframe>
    </div>
    <div>
      <pre>User ID: {{ userId }}</pre>
      <pre>Account Name: {{ accountName }}</pre>
      <pre>iFrame URL: {{ iframeUrl }}</pre>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import decode from 'jwt-decode';
import { useStore } from 'vuex';
import md5 from 'crypto-js/md5';
import { useRoute } from 'vue-router';

const route = useRoute()
const store = useStore();
const userData = computed(() => store.getters['auth/getUserData']);
const authTokenDecoded = computed(() => userData?.value?.authToken ? decode(userData.value?.authToken) : '');
const userId = computed(() => authTokenDecoded.value?.sub || '');
const accountName = computed(() => userData.value?.userName || '');

const isVisible = computed(() => route.query?.['__dev'] === 'true')

const iframeUrl = computed(() => {
  if (userId.value && accountName.value) {
    const token = md5(userId.value).toString();
    return `https://form.typeform.com/to/YO3duoIz#token=${token}&account=${accountName.value}`;
  }
  return '';
});
</script>
